// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.footer {
    /* width: 1016px; */
    width: 100%;
    height: 56px;
    top: 934px;
    left: 398px;
    gap: 20px;
    opacity: 0px;

    .footer_section {
        /* width: 1016px; */
        width: 100%;
        display: flex;
        justify-content: space-around;
        height: 56px;
        padding: 16px;
        gap: 10px;
        border-radius: 15px;
        border: 0.75px;
        opacity: 0px;
        background: #FFFFFF;
        border: 0.75px solid #F8F9FA;
        box-shadow: 0px 3px 15px 0px #EEEEEE80;


        .footer_text {
            /* width: 273px; */
            height: 24px;
            gap: 32px;
            opacity: 0px;

            .footer_first {
                /* width: 273px; */
                height: 24px;
                gap: 0px;
                opacity: 0px;
                font-family: Lexend;
                font-size: 16px;
                font-weight: 400;
                line-height: 24px;
                text-align: left;
                color: #05004E;

            }

            .footer_second {
                /* width: 273px; */
                height: 24px;
                gap: 0px;
                opacity: 0px;
                font-family: Lexend;
                font-size: 16px;
                font-weight: 600;
                line-height: 24px;
                text-align: left;
                color: #05004E;
            }
        }
    }
}

.footerLogo {
    position: relative;
}

.footerLogo .social_options {
    display: flex;
    align-items: center;
    height: auto !important;
    gap: 15px;
    margin-top: 1.5rem;
}

@media (min-width: 768px) {
    .footerLogo .social_options {
        position: absolute;
        min-width: 490px;
        width: 100% !important;
        left: calc(100% + 5rem);
        bottom: .5rem;
        right: 0;
    }


}`, "",{"version":3,"sources":["webpack://./src/styles/footer.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,WAAW;IACX,YAAY;IACZ,UAAU;IACV,WAAW;IACX,SAAS;IACT,YAAY;;IAEZ;QACI,mBAAmB;QACnB,WAAW;QACX,aAAa;QACb,6BAA6B;QAC7B,YAAY;QACZ,aAAa;QACb,SAAS;QACT,mBAAmB;QACnB,cAAc;QACd,YAAY;QACZ,mBAAmB;QACnB,4BAA4B;QAC5B,sCAAsC;;;QAGtC;YACI,kBAAkB;YAClB,YAAY;YACZ,SAAS;YACT,YAAY;;YAEZ;gBACI,kBAAkB;gBAClB,YAAY;gBACZ,QAAQ;gBACR,YAAY;gBACZ,mBAAmB;gBACnB,eAAe;gBACf,gBAAgB;gBAChB,iBAAiB;gBACjB,gBAAgB;gBAChB,cAAc;;YAElB;;YAEA;gBACI,kBAAkB;gBAClB,YAAY;gBACZ,QAAQ;gBACR,YAAY;gBACZ,mBAAmB;gBACnB,eAAe;gBACf,gBAAgB;gBAChB,iBAAiB;gBACjB,gBAAgB;gBAChB,cAAc;YAClB;QACJ;IACJ;AACJ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI;QACI,kBAAkB;QAClB,gBAAgB;QAChB,sBAAsB;QACtB,uBAAuB;QACvB,aAAa;QACb,QAAQ;IACZ;;;AAGJ","sourcesContent":[".footer {\n    /* width: 1016px; */\n    width: 100%;\n    height: 56px;\n    top: 934px;\n    left: 398px;\n    gap: 20px;\n    opacity: 0px;\n\n    .footer_section {\n        /* width: 1016px; */\n        width: 100%;\n        display: flex;\n        justify-content: space-around;\n        height: 56px;\n        padding: 16px;\n        gap: 10px;\n        border-radius: 15px;\n        border: 0.75px;\n        opacity: 0px;\n        background: #FFFFFF;\n        border: 0.75px solid #F8F9FA;\n        box-shadow: 0px 3px 15px 0px #EEEEEE80;\n\n\n        .footer_text {\n            /* width: 273px; */\n            height: 24px;\n            gap: 32px;\n            opacity: 0px;\n\n            .footer_first {\n                /* width: 273px; */\n                height: 24px;\n                gap: 0px;\n                opacity: 0px;\n                font-family: Lexend;\n                font-size: 16px;\n                font-weight: 400;\n                line-height: 24px;\n                text-align: left;\n                color: #05004E;\n\n            }\n\n            .footer_second {\n                /* width: 273px; */\n                height: 24px;\n                gap: 0px;\n                opacity: 0px;\n                font-family: Lexend;\n                font-size: 16px;\n                font-weight: 600;\n                line-height: 24px;\n                text-align: left;\n                color: #05004E;\n            }\n        }\n    }\n}\n\n.footerLogo {\n    position: relative;\n}\n\n.footerLogo .social_options {\n    display: flex;\n    align-items: center;\n    height: auto !important;\n    gap: 15px;\n    margin-top: 1.5rem;\n}\n\n@media (min-width: 768px) {\n    .footerLogo .social_options {\n        position: absolute;\n        min-width: 490px;\n        width: 100% !important;\n        left: calc(100% + 5rem);\n        bottom: .5rem;\n        right: 0;\n    }\n\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
